import { useTranslation } from 'next-i18next';
import { Tooltip } from '@/components/ui/Tooltip';
import { PlanIcon } from '@/shared/components/PlanIcon';
import { type PlanType } from '@/types';
import { cn } from '@/utils/tailwind.util';
export const PlanBadge = ({
  className,
  tooltip = true,
  tooltipContent,
  planType,
  glyph
}: {
  className?: string;
  tooltip?: boolean;
  tooltipContent?: string;
  planType: Exclude<PlanType, 'FREE'>;
  glyph?: React.ReactElement;
}) => {
  const {
    t
  } = useTranslation(['common']);
  const planIcon = <PlanIcon planType={planType} iconSize="2xs" className={className} glyph={glyph} />;
  return tooltip ? <Tooltip side="top" trigger={planIcon}
  // TODO
  content={tooltipContent ?? t('common:common.proBadge.tooltip')} data-sentry-element="Tooltip" data-sentry-component="PlanBadge" data-sentry-source-file="PlanBadge.tsx"></Tooltip> : planIcon;
};
export const WithPlanBadge = ({
  isBadgeVisible,
  children,
  className,
  wrapperClassName,
  align = 'right',
  tooltipContent,
  planType,
  glyph
}: {
  isBadgeVisible: boolean;
  children: React.ReactNode;
  className?: string;
  wrapperClassName?: string;
  align?: 'right' | 'left';
  tooltipContent?: string;
  planType: Exclude<PlanType, 'FREE'>;
  glyph?: React.ReactElement;
}) => {
  return <div className={cn('relative w-fit flex-shrink-0', wrapperClassName)} data-sentry-component="WithPlanBadge" data-sentry-source-file="PlanBadge.tsx">
      {isBadgeVisible && <PlanBadge planType={planType} glyph={glyph} className={cn('origin-center absolute', align === 'right' ? 'right-0 top-0 -translate-y-1/3 translate-x-1/3' : 'left-0 top-0 -translate-y-1/3 -translate-x-1/3', className)} tooltipContent={tooltipContent} />}
      {children}
    </div>;
};